/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
import React, { useEffect } from 'react';
// react library for routing
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
// core components
import AdminFooter from 'components/Footers/AdminFooter';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import Sidebar from 'components/Sidebar/Sidebar';

import withAuthenticator from 'HOCs/withAuthenticator';
import allRoutes from 'routes';
// import { useHistory } from 'react-router';
import { Modal, notification } from 'antd';
import background_img from 'assets/img/olympic/background_bottom.png';
import { checkAdminRole, permission, studentsDemo, testBankAccounts } from 'constants/auth';
import { ROLES } from 'utils/authorization';
import { CURRENT_DOMAIN } from 'constants/settings';
import { isRedirectFromOffline } from 'modules/Offline/OfflineContainer';
import RedirectToBook from 'modules/Offline/Books/RedirectToBook';

const logoUrl = require('assets/sachso/images/logo-sachso.png').default;

const openNotificationWithIcon = (type) => {
  notification[type]({
    message: 'LƯU Ý',
    description: 'Yêu cầu cập nhật đầy đủ thông tin cá nhân!',
  });
};

const Authenticated = ({ loggedInUser }) => {
  const dispatch = useDispatch();
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  const history = useHistory();
  const isStudentDemo = studentsDemo.includes(loggedInUser.email.toLowerCase());
  const isAdmin = checkAdminRole(loggedInUser);
  const isPermission = permission.includes(loggedInUser.email.toLowerCase());
  const isTestBankAcc = testBankAccounts.includes(loggedInUser.email.toLowerCase());

  React.useEffect(() => {
    isRedirectFromOffline(true);
  }, []);

  React.useEffect(() => {
    if (sidenavOpen) {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    } else {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location, sidenavOpen]);

  const allowedRoutes = _.filter(allRoutes, (route) => {
    // if (route.strictedAllowedUsers) return route.strictedAllowedUsers.includes(loggedInUser.email) && !route.roles?.includes(ROLES.ADMINISTRATOR);
    // Đối với các tài khoản học sinh demo thì ẩn menu "Sách điện tử (offline)" đi
    if (isStudentDemo && route.name && route.name.includes('offline')) {
      return false;
    }

    return (
      ((route.roles?.includes(ROLES.AUTHENTICATED) || route.roles?.includes(loggedInUser.role) || (route.roles?.includes(ROLES.PERMISSION) && isPermission) || route.allowedUsers?.includes(loggedInUser.email)) &&
        (!route.strictedAllowedUsers || route.strictedAllowedUsers.includes(loggedInUser.email))) ||
      (route.roles?.includes(ROLES.TESTBANK) && isTestBankAcc) // Tài khoản nhập liệu testBank
    );
  }).map((route) => {
    // Hướng dẫn sử dụng
    if (route.name === 'Hướng dẫn sử dụng') {
      if (isAdmin) {
        return {
          ...route,
          href: `${CURRENT_DOMAIN}/templates/pdfs/HDSD-chuc-nang-Website-Sach-So-Admin.pdf`,
        };
      }
      const fileName = () => {
        switch (loggedInUser?.role) {
          case 'student':
            return 'HDSD-chuc-nang-Website-Sach-So-Hocvien.pdf';
          case 'teacher':
            return 'HDSD-chuc-nang-Website-Sach-So-Giaovien.pdf';
          case 'administrator' || 'manager' || 'admin':
            return 'HDSD-chuc-nang-Website-Sach-So-Admin.pdf';
          default:
            return 'HDSD-chuc-nang-Website-Sach-So-Admin.pdf';
        }
      };
      const href = `${CURRENT_DOMAIN}/templates/pdfs/${fileName()}`;
      return {
        ...route,
        href,
      };
    }
    return route;
  });

  // TODO: Tạm thời dùng users để xác định Administrators
  const administrationRouters = _.filter(allRoutes, (route) => {
    return route.roles?.includes(ROLES.ADMINISTRATOR) && isAdmin && (!route.strictedAllowedUsers || route.strictedAllowedUsers.includes(loggedInUser.email));
  });
  const availableRoutes = _.concat(allowedRoutes, administrationRouters);

  // Filter by
  const getRoutes = React.useCallback((routes) => {
    return routes.map((route, index) => {
      if (route.collapse) {
        return getRoutes(route.views);
      }
      if (route.layout === '/lms') {
        return <Route path={route.layout + route.path} component={route.component} key={index} exact={route.exact} />;
      }
      return null;
    });
  }, []);

  // toggles collapse between mini sidenav and normal
  // eslint-disable-next-line no-unused-vars
  const toggleSidenav = (e) => {
    if (document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-pinned');
      document.body.classList.add('g-sidenav-hidden');
    } else {
      document.body.classList.add('g-sidenav-pinned');
      document.body.classList.remove('g-sidenav-hidden');
    }
    setSidenavOpen(!sidenavOpen);
  };

  const getNavbarTheme = () => {
    return location.pathname.indexOf('admin/alternative-dashboard') === -1 ? 'dark' : 'light';
  };

  // useQuery(
  //   ['login', loggedInUser?.id],
  //   async () => {
  //     const response = await hanhtrangsoClient.post('/login', { email: loggedInUser.email, password: loggedInUser.password });
  //     if (response.data.status === 'success') {
  //       dispatch(login(loggedInUser.email, loggedInUser.password));
  //     }
  //     return response.data;
  //   },
  //   {
  //     retry: false,
  //     refetchInterval: 1000 * 60 * 20, // auto login after 20 minutest
  //     refetchIntervalInBackground: true,
  //     refetchOnWindowFocus: false,
  //   },
  // );

  React.useEffect(() => {
    const bg = document.createElement('div');
    bg.style.position = 'fixed';
    bg.style.top = '0px';
    bg.style.backgroundImage = `url(${background_img})`;
    bg.style.backgroundSize = '100% 100%';
    bg.style.height = '100vh';
    bg.style.width = '100vw';
    bg.style.zIndex = '-999';
    document.body.appendChild(bg);
    return () => {
      document.body.removeChild(bg);
    };
  }, []);

  // Bắt buộc học sinh cập nhật thông tin 'Lớp học'
  useEffect(() => {
    if (loggedInUser?.id && loggedInUser.role === 'student' && !isAdmin && !location.pathname.includes('/profile') && !studentsDemo.includes(loggedInUser.email.toLowerCase())) {
      // Only check on live cuz preview account don't have schoolTypeId
      const { classId, schoolTypeId } = loggedInUser;
      const isNeedUpdate =
        typeof classId !== 'number' ||
        typeof schoolTypeId !== 'number' ||
        (schoolTypeId === 0 && classId !== 0) ||
        (schoolTypeId === 1 && (classId < 1 || classId > 5)) ||
        (schoolTypeId === 2 && (classId < 6 || classId > 9)) ||
        (schoolTypeId === 3 && (classId < 10 || classId > 12)) ||
        schoolTypeId > 3;

      if (isNeedUpdate) {
        Modal.warning({
          title: 'Bạn cần cập nhật lại thông tin lớp học',
          content: 'Vui lòng cập nhật thông tin trước khi tiếp tục sử dụng!',
          centered: true,
          onOk() {
            history.push('/lms/profile');
          },
        });
      }
    }
  }, [loggedInUser?.id, location.pathname]);

  return (
    <React.Fragment>
      <RedirectToBook />
      <Sidebar
        routes={allowedRoutes}
        administrationRouters={administrationRouters}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: '/',
          imgSrc: logoUrl,
          imgAlt: 'Sách số',
        }}
      />
      <div className='main-content' ref={mainContentRef}>
        <AdminNavbar theme={getNavbarTheme()} toggleSidenav={toggleSidenav} sidenavOpen={sidenavOpen} />
        <Switch>
          {getRoutes(availableRoutes)}
          {/* <Redirect from='*' to='/lms/home' /> */}
        </Switch>
        <AdminFooter />
      </div>
      {sidenavOpen ? <div className='backdrop d-xl-none' onClick={toggleSidenav} /> : null}
      {/* Nếu thông tin người dùng bị thiếu thì hiện Popup cho họ vào Profile để cập nhật */}
    </React.Fragment>
  );
};

const Admin = ({ loggedInUser }) => {
  if (!loggedInUser) {
    return <Redirect to={{ pathname: '/' }} />;
  }

  return <Authenticated loggedInUser={loggedInUser} />;
};

export default withAuthenticator(Admin);
